import React, { useState } from 'react';
import SafeIcon from '../common/SafeIcon';
import { getAudioUrl } from '../config';
import { FiVolume2, FiVolumeX } from 'react-icons/fi';

const AudioButton = ({ audioId, text, small = false }) => {
  const [isPlaying, setIsPlaying] = useState(false);

  const playAudio = () => {
    // Try to play from URL first if ID is provided
    if (audioId) {
      // Determine if audioId is a full URL or an ID
      const url = audioId.startsWith('http') ? audioId : getAudioUrl(audioId);
      
      const audio = new Audio(url);
      setIsPlaying(true);
      
      audio.play()
        .then(() => {
          // Playback started successfully
        })
        .catch((err) => {
          console.warn("Audio file not found or playback failed, falling back to TTS", err);
          playTTS();
        });

      audio.onended = () => setIsPlaying(false);
      audio.onerror = () => {
        setIsPlaying(false);
        playTTS();
      };
    } else {
      playTTS();
    }
  };

  const playTTS = () => {
    if (!text) return;
    setIsPlaying(true);
    const utterance = new SpeechSynthesisUtterance(text);
    utterance.lang = 'am-ET'; // Attempt to use Amharic voice if available
    utterance.onend = () => setIsPlaying(false);
    speechSynthesis.speak(utterance);
  };

  return (
    <button
      className={`
        flex items-center justify-center rounded-full transition-all shadow-sm
        ${small ? 'w-8 h-8 text-sm' : 'w-10 h-10 text-base'}
        ${isPlaying 
          ? 'bg-amber-500 text-white scale-110' 
          : 'bg-white text-green-600 border border-green-200 hover:bg-green-50 hover:border-green-300'}
      `}
      onClick={(e) => {
        e.stopPropagation();
        playAudio();
      }}
      title="Play pronunciation"
    >
      <SafeIcon icon={isPlaying ? FiVolumeX : FiVolume2} />
    </button>
  );
};

export default AudioButton;